import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Stack, Typography } from "@mui/material";

import { getUserLocation } from "../../redux";
import {
  HubCancelSubmitGroup,
  HubDialogContent,
  HubHookFormInput,
  HubHookFormRoleSelect,
  HubHookFormWrapper,
} from "../../components";
import { usePostCreateRole } from "../../hooks";
import { useDialogContext } from "../HubDialogWrapper";

const CreateOrganizationRoleContent = ({ locationId }) => {
  const { mutate: postCreateRole, isLoading, isSuccess } = usePostCreateRole();

  const { onClose = () => {} } = useDialogContext();

  const onSubmit = (formData) => {
    const payload = {
      roleId: Number(formData?.roleId),
      name: formData?.roleName,
    };
    postCreateRole(payload);
  };

  useEffect(() => {
    if (isSuccess) onClose();
  }, [isSuccess]);

  return (
    <HubDialogContent largePadding sx={{ overflow: "hidden" }}>
      <HubHookFormWrapper onSubmit={onSubmit}>
        <Stack gap="35px" alignItems="center" width="100%">
          <Stack alignItems="center">
            <Typography variant="h6">Create a New Role</Typography>
            <Typography variant="caption">
              Use a previous role below to copy its permissions
            </Typography>
          </Stack>
          <Stack gap="15px" direction="row" width="100%">
            <HubHookFormRoleSelect
              name="roleId"
              label="Copy Role"
              locationId={locationId}
              useDefault={true}
              required
            />
            <HubHookFormInput
              name="roleName"
              label="New Role Name"
              placeholder="Supervisor"
              required
            />
          </Stack>
          <HubCancelSubmitGroup
            isLoading={isLoading}
            disabled={isLoading}
            label="Create Role"
          />
        </Stack>
      </HubHookFormWrapper>
    </HubDialogContent>
  );
};

const mapStateToProps = (state) => ({
  locationId: getUserLocation(state),
});

export default connect(mapStateToProps)(CreateOrganizationRoleContent);
